import type { CategoryItem } from '../Search/data'

export type ThemeCardItemType = {
  imgUrl: string
  text: string
}

export const casinoCategories: CategoryItem[] = [
  {
    imgUrl: '/assets/search/1.svg',
    text: 'Lobby',
    url: '#',
    active: true,
    isGradient: false,
    color: 'white',
  },
  {
    imgUrl: '/assets/search/2.svg',
    text: 'Prime Roll',
    subText: 'Originals',
    subTextColor: '#DBFE02',
    url: '#',
    active: false,
    isGradient: false,
    color: 'white',
  },
  {
    imgUrl: '/assets/search/9.svg',
    text: 'New release',
    url: '#',
    active: false,
    isGradient: false,
    color: 'white',
  },
  {
    imgUrl: '/assets/search/3.svg',
    text: 'Slots',
    url: '#',
    active: false,
    isGradient: false,
    color: 'white',
  },
  {
    imgUrl: '/assets/search/4.svg',
    text: 'Live casino',
    url: '#',
    active: false,
    isGradient: false,
    color: 'white',
  },
  {
    imgUrl: '/assets/search/5.svg',
    text: 'Roulette',
    url: '#',
    active: false,
    isGradient: false,
    color: 'white',
  },
  {
    imgUrl: '/assets/search/7.svg',
    text: 'Battles',
    url: '#',
    active: false,
    isGradient: false,
    color: 'white',
  },
  {
    imgUrl: '/assets/search/8.svg',
    text: 'Shows',
    url: '#',
    active: false,
    isGradient: false,
    color: 'white',
  },
]

export const themes: ThemeCardItemType[] = [
  {
    imgUrl: '/assets/casino/1.png',
    text: 'Candy',
  },
  {
    imgUrl: '/assets/casino/2.png',
    text: 'Scatter symbols',
  },
  {
    imgUrl: '/assets/casino/3.png',
    text: 'Bonus wheel',
  },
  {
    imgUrl: '/assets/casino/4.png',
    text: 'High volatility',
  },
  {
    imgUrl: '/assets/casino/5.png',
    text: 'Egyptian',
  },
  {
    imgUrl: '/assets/casino/6.png',
    text: 'Mystery',
  },
]
